<template>
  <div class="vue-card-stack__wrapper">
    <!-- animated clone overlay -->
    <div v-if="showClone" class="card-clone" :style="cloneStyle" @transitionend="onTransitionEnd">
      <v-card :style="cloneCardStyle" :dark="!!expandedData.summary" scroll>
        <!-- Close Button -->
        <v-btn icon class="clone-close-btn" @click.stop="closeClone">
          <v-icon x-large :color="expandedData.summary ? 'white' : 'white'">mdi-close</v-icon>
        </v-btn>
        <slot name="card" v-bind:card="{ ...expandedData }">
          <div v-if="expandedData.summary">
            <v-card-title class="font-weight-bold h3 pb-0">
              <v-row no-gutters>
                <v-col cols="12">
                  {{ expandedData.exercise.title }}
                </v-col>
                <v-col cols="12">
                  <v-chip class="mr-1" v-if="expandedData.exercise.deviceShortForm">{{ expandedData.exercise.deviceShortForm }}</v-chip>
                  <v-chip class="mr-1" v-if="expandedData.exercise.deviceTitle">{{ expandedData.exercise.deviceTitle }}</v-chip>
                  <v-chip class="mr-1" v-if="expandedData.exercise.deviceCategory">{{ expandedData.exercise.deviceCategory }}</v-chip>
                </v-col>
              </v-row>
            </v-card-title>
            <v-row no-gutters>
              <MuscleDiagram
                cols="5"
                borderRadius="25px"
                background="#555"
                :hideTagWindows="true"
                :exercises="expandedData.exercise"
                :activeClasses="expandedData.exercise.tags.map((tag) => tag.class)" />
            </v-row>
            <v-card-title class="font-weight-bold h4 pb-0">Deine Werte (Gesamt)</v-card-title>
            <v-row no-gutters>
              <v-col class="mx-2">
                <v-card flat class="rounded-xl pa-2" style="background-color: #555; place-items: center">
                  <number class="h6 font-weight-bold" :from="0" :to="expandedData.sets.length"></number><span class="h6 font-weight-bold">Sätze</span>
                  <v-img style="filter: grayscale(0.7)" height="35px" width="35px" src="/img/workout/layers.png"></v-img>
                </v-card>
              </v-col>
              <v-col class="mx-2">
                <v-card flat class="rounded-xl pa-2" style="background-color: #555; place-items: center">
                  <number class="h6 font-weight-bold" :from="0" :to="expandedData.summary.totalReps"></number
                  ><span class="h6 font-weight-bold">WH</span>
                  <v-img style="filter: grayscale(0.7)" height="35px" width="35px" src="/img/workout/circular-chart.png"></v-img>
                </v-card>
              </v-col>
              <v-col class="mx-2">
                <v-card flat class="rounded-xl pa-2" style="background-color: #555; place-items: center">
                  <number class="h6 font-weight-bold" :from="0" :to="expandedData.summary.totalWeight"></number>
                  <span class="h6 font-weight-bold">kg</span>
                  <v-img height="35px" width="35px" src="/img/workout/kettlebell.png"></v-img>
                </v-card>
              </v-col>
            </v-row>
            <v-card-title class="font-weight-bold h4 pb-0">Deine besten Sätze</v-card-title>
            <v-row no-gutters>
              <v-col class="ml-2 mb-2" cols="auto" v-if="expandedData.summary.maxWeightStep">
                <v-card flat class="rounded-xl pa-1" style="background-color: #555; place-items: center">
                  <span>{{ $moment(expandedData.summary.maxWeightStep.date).fromNow() }}</span>
                  <v-card-title class="font-weight-bold pt-0">max. Gewicht</v-card-title>
                  <v-card-subtitle class="">
                    <span class="font-weight-bold">{{ expandedData.summary.maxWeightStep.weight }} kg </span> x
                    {{ expandedData.summary.maxWeightStep.reps }} WH
                  </v-card-subtitle>
                </v-card>
              </v-col>
              <v-col class="ml-2 mb-2" cols="auto" v-if="expandedData.summary.maxVolumeStep">
                <v-card flat class="rounded-xl pa-1" style="background-color: #555; place-items: center">
                  <span>{{ $moment(expandedData.summary.maxVolumeStep.date).fromNow() }}</span>

                  <v-card-title class="font-weight-bold pt-0">max. Volumen</v-card-title>
                  <v-card-subtitle class="">
                    {{ expandedData.summary.maxVolumeStep.weight }} kg x {{ expandedData.summary.maxVolumeStep.reps }} WH =
                    <span class="font-weight-bold"
                      >{{ expandedData.summary.maxVolumeStep.weight * expandedData.summary.maxVolumeStep.reps }} kg
                    </span>
                  </v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>
            <v-card-title class="font-weight-bold h4 pb-0">Verlauf</v-card-title>
            <apexchart
              v-if="expandedData.sets.length >= 3"
              style="max-width: 600px"
              class="ma-auto rounded-0"
              :options="chartOptions"
              :series="chartItems"></apexchart>
          </div>
          <div v-else>
            <!-- default content if no slot -->
            <v-card-title class="font-weight-bold h3">
              {{ expandedData.execution ? expandedData.execution.title : expandedData.exercise.title }}
            </v-card-title>
            <v-card-subtitle class="font-weight-bold h4">
              am {{ expandedData.execution ? $moment(expandedData.execution.createdAt).format("DD. MMM YYYY") : "Kein Datum" }}
            </v-card-subtitle>
            <v-row no-gutters class="justify-space-between" v-if="false">
              <v-col class="mx-2">
                <v-card flat class="rounded-xl pa-2" style="background-color: #80808059; place-items: center">
                  <number class="h6 font-weight-bold" :from="0" :to="expandedData.execution.caloriesBurned"></number
                  ><span class="h6 font-weight-bold">kcal</span>
                  <v-img height="35px" width="35px" src="/img/workout/calories.png"></v-img>
                </v-card>
              </v-col>
              <v-col class="mx-2">
                <v-card flat class="rounded-xl pa-2" style="background-color: #80808059; place-items: center">
                  <number class="h6 font-weight-bold" :from="0" :to="expandedData.execution.duration"></number
                  ><span class="h6 font-weight-bold">Minuten</span>
                  <v-img height="35px" width="35px" src="/img/workout/stopwatch.png"></v-img>
                </v-card>
              </v-col>
              <v-col class="mx-2">
                <v-card flat class="rounded-xl pa-2" style="background-color: #80808059; place-items: center">
                  <number class="h6 font-weight-bold" :from="0" :to="expandedData.execution.liftedWeight"></number>
                  <span class="h6 font-weight-bold">kg</span>
                  <v-img height="35px" width="35px" src="/img/workout/kettlebell.png"></v-img>
                </v-card>
              </v-col>
            </v-row>
            <v-card-title class="font-weight-bold">Ausgeführte Übungen</v-card-title>
            <v-row no-gutters>
              <v-col cols="12"> <v-card></v-card> </v-col
            ></v-row>
          </div>
        </slot>
      </v-card>
    </div>

    <div class="vue-card-stack__stack" :style="{ height: containerHeight, width: containerWidth }">
      <div
        class="vue-card-stack__card"
        v-for="(card, cardIndex) in stack.slice(0, _maxVisibleCards)"
        :key="card._id"
        :style="{
          display: card.display,
          width: card.width,
          height: `${card.height}px`,
          zIndex: card.zIndex,
          transition: `transform ${isDragging ? 0 : speed}s ease, opacity ${speed}s ease`,
          transform: `translate(0, ${card.yPos}px) scale(${card.scale})`,
          cursor: showClone ? 'default' : 'grab',
        }"
        @click="!isDragging && expandCard(cardIndex, $event)">
        <slot v-bind:card="{ ...card }" name="card">
          <!-- existing card content -->
          <v-card
            :style="exercises ? 'background-color: ' + grayShades[cardIndex] : 'background-color: ' + card.backgroundColor"
            class="rounded-xl"
            style="height: 200px">
            <div v-if="exercises">
              <v-card-title class="font-weight-bold">
                {{ card.exercise.title }}
              </v-card-title>
              <v-row no-gutters style="max-height: 136px">
                <v-col cols="5" class="mx-2">
                  <v-img
                    class="rounded-lg"
                    style="max-height: 120px"
                    contain
                    v-if="cardIndex === activeCardIndex"
                    :src="getImageForExercise(card.exercise)"></v-img>
                </v-col>
                <v-col cols="auto">
                  <span v-if="card.summary.maxWeightStep"> max. Gewicht: {{ card.summary.maxWeightStep.weight + " kg" }} </span>
                </v-col>
              </v-row>
              <v-btn color="red" icon large absolute top right><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div v-else>
              <v-btn color="red" icon large absolute top right><v-icon>mdi-close</v-icon></v-btn>

              <v-card-title class="font-weight-bold">
                {{ card.execution ? card.execution.title : "Kein Titel" }}
              </v-card-title>
              <v-card-subtitle class="font-weight-bold">
                am {{ card.execution ? $moment(card.execution.createdAt).format("DD. MMM YYYY") : "Kein Datum" }}
              </v-card-subtitle>
              <v-row no-gutters>
                <v-col cols="2" class="mx-2">
                  <v-card flat class="rounded-xl pa-2" style="background-color: #80808059; place-items: center">
                    <number v-if="cardIndex === activeCardIndex" class="h6 font-weight-bold" :from="0" :to="card.execution.caloriesBurned"></number>
                    <span v-else class="h6 font-weight-bold">0</span>
                    <v-img height="35px" width="35px" src="/img/workout/calories.png"></v-img>
                  </v-card>
                </v-col>
                <v-col cols="2" class="mx-2">
                  <v-card flat class="rounded-xl pa-2" style="background-color: #80808059; place-items: center">
                    <number v-if="cardIndex === activeCardIndex" class="h6 font-weight-bold" :from="0" :to="card.execution.duration"></number>
                    <span v-else class="h6 font-weight-bold">0</span>
                    <v-img height="35px" width="35px" src="/img/workout/stopwatch.png"></v-img>
                  </v-card>
                </v-col>
                <v-col cols="3" class="mx-2">
                  <v-card flat class="rounded-xl pa-2" style="background-color: #80808059; place-items: center">
                    <number v-if="cardIndex === activeCardIndex" class="h6 font-weight-bold" :from="0" :to="card.execution.liftedWeight"></number>
                    <span v-else class="h6 font-weight-bold">0</span>
                    <v-img height="35px" width="35px" src="/img/workout/kettlebell.png"></v-img>
                  </v-card>
                </v-col>
              </v-row>
              <v-img
                v-if="cardIndex === activeCardIndex"
                style="position: absolute; bottom: 10px; right: 8px"
                height="68"
                width="68"
                :src="card.img"></v-img>
            </div>
          </v-card>
        </slot>
      </div>
    </div>
    <slot name="nav" v-bind="{ activeCardIndex: originalActiveCardIndex, onNext, onPrevious }"></slot>
  </div>
</template>

<script>
import { debounce } from "./utils/debounce"
import { mapGetters, mapActions, mapState } from "vuex"
import MuscleDiagram from "../PlanRunInteractiveHuman.vue"

export default {
  name: "TrainingsHubCardStack",
  components: {
    MuscleDiagram,
  },
  props: {
    exercises: { type: Boolean, default: false },
    cards: { type: Array, default: () => [] },
    backgroundColors: { type: Array, default: () => [] },
    cardWidth: { default: "100%" },
    cardHeight: { type: Number, default: 250 },
    stackWidth: { type: [Number, String], default: null },
    sensitivity: { type: Number, default: 0.25 },
    maxVisibleCards: { type: Number, default: 3 },
    scaleMultiplier: { type: Number, default: 0.5 },
    speed: { type: Number, default: 0.2 },
    paddingHorizontal: { type: Number, default: 20 },
    paddingVertical: { type: Number, default: 0 },
  },
  data() {
    return {
      stack: [],
      width: 0,
      activeCardIndex: 0,
      isDragging: false,
      dragStartY: 0,
      isDraggingDown: false,
      grayShades: ["#F9F9F9", "#E0E0E0", "#CCCCCC", "#B3B3B3", "#999999"],
      showClone: false,
      isClosing: false,
      cloneStyle: {},
      cloneCardStyle: {},
      originalCloneStyle: {},
      expandedData: {},
    }
  },
  mounted() {
    this.init()
    window.addEventListener("resize", this.handleResize)
    this.$el.addEventListener(this.touchStartEvent, this.onTouchStart)
    document.addEventListener(this.touchEndEvent, this.onTouchEnd)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
    this.$el.removeEventListener(this.touchStartEvent, this.onTouchStart)
    document.removeEventListener(this.touchEndEvent, this.onTouchEnd)
  },
  computed: {
    ...mapGetters("deviceStore", ["exerciseList"]),
    chartItems() {
      if (!this.expandedData.sets) return []

      const data = this.expandedData.sets.map((set) => ({
        x: this.$moment(set.date).format("DD.MM.YYYY"),
        y: Math.round(set.steps.reduce((acc, step) => acc + step.weight, 0) / set.steps.length),
      }))
      console.log(data)
      return [
        {
          name: "Ø Gewicht",
          data,
        },
      ]
    },
    chartOptions() {
      return {
        colors: [
          this.$vuetify.theme.themes.light.primary,
          this.$vuetify.theme.themes.light.darkenprimary1,
          this.$vuetify.theme.themes.light.darkenprimary2,
        ],
        chart: {
          toolbar: {
            show: true,
            tools: {
              download: false,
              selection: true,
              pan: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              reset: true,
            },
          },
          zoom: {
            enabled: true,
            type: "x",
            resetIcon: {
              offsetX: -10,
              offsetY: 0,
              fillColor: "#293a16",
              strokeColor: "#37474F",
            },
            selection: {
              background: "#90CAF9",
              border: "#0D47A1",
            },
          },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
          type: "area",
        },
        xaxis: {
          type: "category", // wir haben Strings wie "DD.MM.YYYY"
          labels: {
            show: false,
          },
          tickAmount: Math.min(this.chartItems[0]?.data.length - 1 || 1, 4), // max 4 Teilstriche
          min:
            this.chartItems[0].data.length >= 3
              ? this.chartItems[0].data.length - 3
              : this.chartItems[0].data.length - this.chartItems[0].data.length,
          max: this.chartItems[0].data.length,
        },
        yaxis: {
          labels: {
            formatter: (value) => value.toString() + "kg", // ganze Zahlen
          },
        },
      }
    },
    _stackWidth() {
      if (!this.stackWidth) return this.cardWidth + this.paddingHorizontal * 2
      if (typeof this.stackWidth === "number") return this.stackWidth
      return this.width || this.$el.clientWidth
    },
    containerWidth() {
      if (!this.stackWidth) return `${this.cardWidth + this.paddingHorizontal * 2}px`
      if (typeof this.stackWidth === "number") return `${this.stackWidth}px`
      return this.stackWidth
    },
    containerHeight() {
      return `${this.cardHeight + this.paddingVertical * 2}px`
    },
    _maxVisibleCards() {
      return this.maxVisibleCards > this.cards.length ? this.cards.length : this.maxVisibleCards
    },
    _scaleMultiplier() {
      return 0.05
    },
    overlapOffset() {
      return 20
    },
    verticalStackRestPoints() {
      return this.cards.map((_, i) => this.paddingVertical + i * this.overlapOffset)
    },
    cardDefaults() {
      return this.cards.map((_, i) => {
        const baseY = this.verticalStackRestPoints[i]
        return {
          opacity: 1,
          display: "block",
          xPos: this.paddingHorizontal,
          yPos: baseY,
          scale: i === 0 ? 1 : 1 - i * this._scaleMultiplier,
          width: this.cardWidth,
          height: this.cardHeight,
          zIndex: this.cards.length - i,
          isDragging: this.isDragging,
        }
      })
    },
    isTouch() {
      return "ontouchstart" in window
    },
    dragEvent() {
      return this.isTouch ? "touchmove" : "mousemove"
    },
    touchStartEvent() {
      return this.isTouch ? "touchstart" : "mousedown"
    },
    touchEndEvent() {
      return this.isTouch ? "touchend" : "mouseup"
    },
    originalActiveCardIndex() {
      return this.stack[this.activeCardIndex]?._index || 0
    },
  },
  methods: {
    getExercise(id) {
      return this.exerciseList.find((ex) => ex._id === id)
    },
    getImageForExercise(ex) {
      if (ex.picture) return this.getImageUrl(ex.picture)
      if (ex.manual[0]?.picture) return this.getImageUrl(ex.manual[0].picture)
    },
    getImageUrl(id) {
      return "/img/uebungen/" + id.replace(/\.[^/.]+$/, "") + ".webp"
    },
    init() {
      this.stack = this.cards.map((card, i) => ({ _id: Date.now() + i, _index: i, ...card, ...this.cardDefaults[i] }))
    },
    rebuild() {
      this.$nextTick(() => {
        this.stack = this.stack.map((c, i) => ({ ...c, ...this.cardDefaults[i] }))
      })
    },
    handleResize: debounce(function () {
      this.width = this.$el.clientWidth
      this.rebuild()
    }, 250),
    expandCard(idx, event) {
      const orig = event.currentTarget
      const rect = orig.getBoundingClientRect()
      // store initial style for reverse animation
      this.originalCloneStyle = {
        top: `${rect.top}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`,
        borderRadius: getComputedStyle(orig).borderRadius,
      }
      this.expandedData = { ...this.stack[idx] }

      for (let set of this.expandedData.sets) {
        set.exercise = this.getExercise(set.exercise_id)
      }
      console.log(this.expandedData)
      // set starting style
      this.cloneStyle = {
        position: "fixed",
        top: this.originalCloneStyle.top,
        left: this.originalCloneStyle.left,
        width: this.originalCloneStyle.width,
        height: this.originalCloneStyle.height,
        zIndex: 1000,
        transition: "all 0.3s ease",
        transformOrigin: "center top",
        borderRadius: this.originalCloneStyle.borderRadius,
      }
      this.cloneCardStyle = {
        width: "100%",
        height: "100%",
        overflow: "auto",
      }
      if (!this.exercises) {
        this.cloneCardStyle.backgroundColor = this.stack[idx].backgroundColor
      }
      this.showClone = true
      this.$nextTick(() => {
        // animate to full screen
        Object.assign(this.cloneStyle, {
          top: "0",
          left: "0",
          width: "100vw",
          height: "100vh",
          borderRadius: "0",
        })
      })
    },
    closeClone() {
      // animate back to original position
      this.isClosing = true
      Object.assign(this.cloneStyle, {
        top: this.originalCloneStyle.top,
        left: this.originalCloneStyle.left,
        width: this.originalCloneStyle.width,
        height: this.originalCloneStyle.height,
        borderRadius: this.originalCloneStyle.borderRadius,
      })
    },
    onTransitionEnd() {
      if (this.isClosing) {
        // finished closing animation
        this.showClone = false
        this.isClosing = false
      } else {
        // after expand animation
        this.$emit("expanded", this.expandedData)
      }
    },
    onNext() {
      this.stack.push(this.stack.shift())
      this.rebuild()
    },
    onPrevious() {
      this.stack.unshift(this.stack.pop())
      this.rebuild()
    },
    updateStack() {
      const a = this.stack[this.activeCardIndex]
      if (!a) return
      const rest = this.verticalStackRestPoints[this.activeCardIndex]
      const dist = a.yPos - rest
      const minD = (this.cardHeight + this.paddingVertical) / (1 / this.sensitivity)
      this.$emit("move", 0)
      if (this.isDraggingDown ? dist > minD : Math.abs(dist) > minD) {
        this.isDraggingDown ? this.onPrevious() : this.onNext()
      } else {
        this.rebuild()
      }
    },
    moveStack(dragY) {
      const off = dragY - this.dragStartY
      this.$emit("move", off / (this.cardHeight + this.paddingVertical))
      this.activeCardIndex = 0
      this.stack = this.stack.map((c, i) => ({
        ...c,
        ...this.cardDefaults[i],
        yPos: i === 0 ? this.cardDefaults[i].yPos + off : this.cardDefaults[i].yPos,
      }))
    },
    getDragYPos(e) {
      return this.isTouch ? e.touches[0].clientY : e.clientY
    },
    onTouchStart(e) {
      this.isDragging = true
      this.dragStartY = this.getDragYPos(e)
      document.addEventListener(this.dragEvent, this.onDrag, { passive: false })
    },
    onTouchEnd() {
      this.isDragging = false
      document.removeEventListener(this.dragEvent, this.onDrag)
      this.updateStack()
    },
    onDrag(e) {
      e.preventDefault()
      const y = this.getDragYPos(e)
      this.isDraggingDown = y > this.dragStartY
      this.moveStack(y)
    },
  },
}
</script>

<style scoped>
.vue-card-stack__wrapper {
  position: relative;
  touch-action: none;
}
.vue-card-stack__stack {
  position: relative;
  overflow: hidden;
  touch-action: none;
}
.vue-card-stack__card {
  position: absolute;
  transform-origin: center top;
}
.card-clone {
  pointer-events: auto;
  position: fixed;
  top: 0;
  left: 0;
}
.clone-close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1001;
}
</style>
